import { Toast } from '@base-ui/react/toast'
import { useT } from '@/i18n/use-t'
import { cn } from '@/lib/cn'
import { XIcon } from './icons'

export const toastManager = Toast.createToastManager()

export type ToastTone = 'success' | 'error' | 'warn' | 'info'

export function notify(title: string, tone: ToastTone = 'info', description?: string) {
  toastManager.add({ title, description, type: tone })
}

const TONES: Record<string, string> = {
  success: 'border-cyan text-cyan-text',
  error: 'border-danger text-danger-text',
  warn: 'border-amber text-amber-text',
  info: 'border-line-strong text-moon',
}

function ToastList() {
  const { toasts } = Toast.useToastManager()
  const t = useT()
  return toasts.map((toast) => (
    <Toast.Root
      key={toast.id}
      toast={toast}
      className={cn(
        'pointer-events-auto flex w-full items-start gap-3 rounded-[14px] border bg-night px-4 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.45)] transition-[opacity,transform] duration-200 data-[ending-style]:translate-y-2 data-[ending-style]:opacity-0 data-[starting-style]:translate-y-2 data-[starting-style]:opacity-0',
        TONES[toast.type ?? 'info'],
      )}
    >
      <div className="min-w-0 flex-1">
        <Toast.Title className="text-sm font-semibold" />
        <Toast.Description className="mt-0.5 text-[13px] text-haze" />
      </div>
      <Toast.Close
        aria-label={t('common.close')}
        className="-mr-1 inline-flex size-8 items-center justify-center rounded-lg text-haze hover:bg-dusk"
      >
        <XIcon size={16} />
      </Toast.Close>
    </Toast.Root>
  ))
}

export function Toaster() {
  const t = useT()
  return (
    <Toast.Portal>
      <Toast.Viewport
        aria-label={t('ui.notifications')}
        className="fixed bottom-[96px] left-1/2 z-[100] flex w-[min(420px,calc(100vw-32px))] -translate-x-1/2 flex-col gap-2 md:bottom-6"
      >
        <ToastList />
      </Toast.Viewport>
    </Toast.Portal>
  )
}

export const ToastProvider = Toast.Provider
